import React, { useState } from 'react';
import { X } from 'lucide-react';

const DomainModal = ({ isOpen, onClose, onSubmit }) => {
  const [domainData, setDomainData] = useState({
    host: '',
    path: '/',
    sourceIPs: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(domainData);
    handleCancel();
  };

  const handleCancel = () => {
    setDomainData({
      host: '',
      path: '/',
      sourceIPs: ''
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm transition-opacity"></div>

      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
          <div className="flex items-center justify-between p-5 border-b">
            <h3 className="text-lg font-bold text-gray-800">
              Add New Domain
            </h3>
            <button
              onClick={handleCancel}
              className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 transition-colors"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-gray-700 text-sm font-medium block mb-1">
                  Host 
                </label>
                <input
                  type="text"
                  value={domainData.host}
                  onChange={(e) => setDomainData({ ...domainData, host: e.target.value })}
                  placeholder="e.g., api.example.com"
                  className="w-full px-3 py-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>

              <div>
                <label className="text-gray-700 text-sm font-medium block mb-1">
                  Path
                </label>
                <input
                  type="text"
                  value={domainData.path}
                  onChange={(e) => setDomainData({ ...domainData, path: e.target.value })}
                  placeholder="e.g., /api/*"
                  className="w-full px-3 py-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>

              <div>
                <label className="text-gray-700 text-sm font-medium block mb-1">
                  Source IP (optional)
                </label>
                <input
                  type="text"
                  value={domainData.sourceIPs}
                  onChange={(e) => setDomainData({ ...domainData, sourceIPs: e.target.value })}
                  placeholder="e.g., 192.168.1.1"
                  className="w-full px-3 py-2 border rounded-md focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                />
                <p className="mt-1 text-xs text-gray-500">
                  Leave empty to allow all source IPs
                </p>
              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  type="button"
                  onClick={handleCancel}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Add Domain
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomainModal;